import React from "react";
import { DocumentTextIcon } from "@heroicons/react/24/outline";

const ResumeCard = ({ resume }) => {
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  // resume.thumbnail is a Base64 JPEG (or URL) saved from the resume preview.
  const hasThumbnail = Boolean(resume.thumbnail);

  return (
    <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-lg hover:shadow-cyan-500/50 transition-shadow duration-300 ease-in-out cursor-pointer overflow-hidden flex flex-col h-full">
      {/* Letter-proportioned (8.5 x 11) page preview, scaled to the card width */}
      <div className="w-full aspect-[8.5/11] overflow-hidden border-b border-gray-700 bg-white">
        {hasThumbnail ? (
          <img
            src={resume.thumbnail}
            alt={resume.resume_name}
            className="w-full h-full object-contain object-top"
          />
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center gap-2 bg-neutral-100 text-neutral-400">
            <DocumentTextIcon className="h-12 w-12" />
            <span className="text-xs font-medium">No preview yet</span>
          </div>
        )}
      </div>
      <div className="p-4">
        <h3 className="text-lg font-semibold text-white truncate">{resume.resume_name}</h3>
        <p className="text-sm text-gray-400 mt-1">Last edited: {formatDate(resume.last_edited)}</p>
      </div>
    </div>
  );
};

export default ResumeCard;